// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cT_iZ","top":"styles_top__1sPsb"};